<app-admin-page-shell
  titleKey="app.admin.billing.title"
  subtitleKey="app.admin.billing.subtitle"
  [panelled]="false"
>
  @if (isLoading()) {
    <div class="billing__status">
      <mat-spinner diameter="36"></mat-spinner>
      <p>{{ 'app.admin.billing.loading' | translate }}</p>
    </div>
  } @else if (hasError()) {
    <div class="billing__status billing__status--error">
      <p>{{ 'app.admin.billing.error' | translate }}</p>
      <app-cta-button size="small" (clicked)="load()">
        <span cta-label>{{ 'app.admin.billing.retry' | translate }}</span>
      </app-cta-button>
    </div>
  } @else {
    <div class="billing__toolbar">
      <p class="billing__hint">{{ 'app.admin.billing.hint' | translate }}</p>
      <div class="billing__save-row">
        @for (plan of planColumns(); track plan.code) {
          <app-cta-button
            size="small"
            [loading]="isSaving()"
            [disabled]="isSaving()"
            (clicked)="savePlan(plan.code)"
          >
            <span cta-label>
              {{ 'app.admin.billing.savePlan' | translate: { plan: plan.displayName } }}
            </span>
          </app-cta-button>
        }
      </div>
    </div>

    <div class="billing__table-wrap">
      <table class="billing-matrix">
        <thead>
          <tr>
            <th class="billing-matrix__feature">
              {{ 'app.admin.billing.feature' | translate }}
            </th>
            @for (plan of planColumns(); track plan.code) {
              <th>
                <div class="billing-matrix__plan">
                  <span class="billing-matrix__plan-name">{{ plan.displayName }}</span>
                  <code class="billing-matrix__plan-code">{{ plan.code }}</code>
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (group of groups(); track group[0]) {
            <tr class="billing-matrix__group">
              <td [attr.colspan]="1 + planColumns().length">{{ group[0] }}</td>
            </tr>
            @for (entry of group[1]; track entry.key) {
              <tr>
                <td class="billing-matrix__feature">
                  <div class="billing-matrix__feature-copy">
                    <span class="billing-matrix__label">{{ entry.label }}</span>
                    <code class="billing-matrix__key">{{ entry.key }}</code>
                    <span class="billing-matrix__desc">{{ entry.description }}</span>
                  </div>
                </td>
                @for (plan of planColumns(); track plan.code) {
                  <td>
                    @if (cell(plan.code, entry.key); as draft) {
                      <div class="billing-cell" [class.billing-cell--capability]="entry.isCapability">
                        <select
                          class="billing-cell__state"
                          [ngModel]="draft.state"
                          (ngModelChange)="setState(plan.code, entry.key, $event)"
                        >
                          <option value="disabled">
                            {{ 'app.admin.billing.state.disabled' | translate }}
                          </option>
                          @if (!entry.isCapability) {
                            <option value="limited">
                              {{ 'app.admin.billing.state.limited' | translate }}
                            </option>
                          }
                          <option value="unlimited">
                            {{ 'app.admin.billing.state.unlimited' | translate }}
                          </option>
                        </select>

                        @if (entry.isCapability) {
                          <span class="billing-cell__capability-copy">
                            {{ draft.state === 'disabled' ? 'Off' : 'On' }}
                          </span>
                        }

                        @if (!entry.isCapability && draft.state === 'limited') {
                          <input
                            class="billing-cell__value"
                            type="number"
                            [ngModel]="draft.value"
                            (ngModelChange)="setValue(plan.code, entry.key, $event)"
                          />
                        }

                        @if (!entry.isCapability && draft.state !== 'disabled') {
                          <div class="billing-cell__meter">
                            <select
                              [ngModel]="draft.subject"
                              (ngModelChange)="setSubject(plan.code, entry.key, $event)"
                              [attr.aria-label]="'app.admin.billing.subject' | translate"
                            >
                              @for (s of entry.allowedSubjects; track s) {
                                <option [value]="s">{{ s }}</option>
                              }
                            </select>
                            <select
                              [ngModel]="draft.period"
                              (ngModelChange)="setPeriod(plan.code, entry.key, $event)"
                              [attr.aria-label]="'app.admin.billing.period' | translate"
                            >
                              @for (p of entry.allowedPeriods; track p) {
                                <option [value]="p">{{ p }}</option>
                              }
                            </select>
                          </div>
                        }
                      </div>
                    }
                  </td>
                }
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
</app-admin-page-shell>
